import axios from 'axios'
import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export function getSiteInfo() {
  return request({ url: '/admin/config/siteInfo', method: 'post', data: {} })
}

export function getConfigList() {
  return request({ url: '/admin/config/list', method: 'post', data: {} })
}

export function updateConfig(updates) {
  return request({ url: '/admin/config/update', method: 'post', data: { updates } })
}

export function uploadConfigImage(file) {
  const formData = new FormData()
  formData.append('image', file)
  return axios.post(process.env.VUE_APP_BASE_API + '/admin/config/uploadImage', formData, {
    headers: {
      Authorization: 'Bearer ' + getToken(),
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => {
    if (res.data.code !== 0) {
      throw new Error(res.data.message || '上传失败')
    }
    return res.data
  })
}
